const FilingFrequencyFilters = {
  
    EcListingFilter: (filingFrequencies) => {
      let ecListingFilingFrequenciesIds = [1, 2, 3, 7, 8, 9];

      return ecListingFilingFrequenciesIds.reduce((acc, id) => {
        return Object.assign(acc, {[id]: filingFrequencies[id]});
      }, {}); 
    },

    IntrastatListingFilter: (filingFrequencies) => {
      let ecListingFilingFrequenciesIds = [1, 2, 3];

      return ecListingFilingFrequenciesIds.reduce((acc, id) => {
        return Object.assign(acc, {[id]: filingFrequencies[id]});
      }, {});
    },

    LocalListingFilter: (filingFrequencies) => {
      let localListingFilingFrequenciesIds = [1, 2, 3, 9, 7];

      return localListingFilingFrequenciesIds.reduce((acc, id) => {
        return Object.assign(acc, {[id]: filingFrequencies[id]});
      }, {});
    },
    extrastatFilter: (filingFrequencies) => {
      let extrastatFilingFrequenciesIds = [1];

      return extrastatFilingFrequenciesIds.reduce((acc, id) => {
        return Object.assign(acc, {[id]: filingFrequencies[id]});
      }, {});
    },
    OSSImportFilter: (filingFrequencies) => {
        let ossImportFilingFrequenciesIds = [1,7];

        return ossImportFilingFrequenciesIds.reduce((acc, id) => {
            return Object.assign(acc, {[id]: filingFrequencies[id]});
        }, {});
    },
    OSSFilter: (filingFrequencies) => {
        let ossFilingFrequenciesIds = [2,7];

        return ossFilingFrequenciesIds.reduce((acc, id) => {
            return Object.assign(acc, {[id]: filingFrequencies[id]});
        }, {});
    },
  };
  
  export default FilingFrequencyFilters;